import accounts from './accounts.json';
import auth from './auth.json';
import balance from './balance.json';
import compliance from './compliance.json';
import movements from './movements.json';
import regulatoryPackages from './regulatory-packages.json';
import reports from './reports.json';

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T058
 * @taskId T059a
 * @taskId T059b
 * @taskId T061
 * @taskId T060
 * @taskId T653
 * @taskId T657
 * @see functional/Specs/specs_cycle-2.md HU-27-BE
 * @see functional/Specs/specs_cycle-2.md HU-06-FE
 * @see functional/Specs/specs_cycle-2.md HU-13-FE
 * @see functional/Specs/specs_cycle-2.md HU-07-FE
 * @see functional/Specs/specs_cycle-2.md HU-11-FE
 * @see functional/Cycles/cycle-5/tasks.md HU-29-FE
 * @see functional/Cycles/cycle-5/tasks.md HU-99-FE
 */
export const appResources = {
  'es-AR': {
    accounts,
    auth,
    balance,
    compliance,
    movements,
    regulatoryPackages,
    reports,
  },
} as const;

export type AppResources = typeof appResources;
